import { render, staticRenderFns } from "./UserJoinStatistics.vue?vue&type=template&id=4d8702b8&"
import script from "./UserJoinStatistics.vue?vue&type=script&lang=js&"
export * from "./UserJoinStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8702b8')) {
      api.createRecord('4d8702b8', component.options)
    } else {
      api.reload('4d8702b8', component.options)
    }
    module.hot.accept("./UserJoinStatistics.vue?vue&type=template&id=4d8702b8&", function () {
      api.rerender('4d8702b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/user-join/UserJoinStatistics.vue"
export default component.exports